/** True when integrated location has at least one weekday with a valid start/end slot (same idea as Settings save). */
export function hasConfiguredBusinessHours(businessHours) {
  if (!Array.isArray(businessHours)) return false;
  return businessHours.some((day) =>
    (day?.timePeriods || []).some((p) => p?.startTime && p?.endTime),
  );
}
